import styled from "styled-components";

export const TitleBoxWrapper = styled.div`
  margin-top: 20px;
`;

export const HorizontalLine = styled.hr`
  width: 100%;
  margin: 0;
  margin-top: 2px;
  margin-bottom: 2px;
`;

export const TitleText = styled.p`
  font-size: medium;
  margin: 0;
  margin-left: 10px;
`;
